import { createContext, useState } from 'react';
import { getJwtToken } from 'utils/functions/session-storage';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    token: getJwtToken()
  });
  const [token, setToken] = useState(getJwtToken());

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        token,
        setToken
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
